import src from "IMAGE";
export default { src, width: 341, height: 45, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/webp;base64,UklGRnIAAABXRUJQVlA4TGUAAAAvBwAAAM1VICICHggkAAAAAID9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgBgAAEAAEB4IBIAAAAAAOffAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODICcixKwA="};
